import { createComponent } from '@front/utils/alpine';
import { withEl, createNode } from '@front/utils';
import prestashop from 'prestashop';

interface Product {
    id: number;
    name: string;
    gift_id_cart_rule: string;
    gift_code: string;
    gift_in_cart: Boolean;
    gift_add_url: string;
    gift_delete_url: string;
    manufacturer_name: string;
    href: string;
    img_width: number;
    img_height: number;
    img_src: string;
    img_alt: string;
    img_title: string;
}

export default createComponent(() => ({
    isOpen: false,
    selectedGiftCode: null,
    selectedProduct: null as Product | null,

    init() {
        this.initGifts(true);
        prestashop.on('updateCart', this.initGifts.bind(this));
    },

    /**
     * Init de la liste des cadeaux et mise a jour du panier en modal
     */
    async initGifts(init) {

        if (
            prestashop !== null
            && prestashop.page !== null
            && prestashop.page.canonical !== ''
            && prestashop.page.canonical !== null
        ) {
            let formData = new FormData();
            formData.append('ajax', '1');
            formData.append('action','potentialGifts');

            const response = await fetch(prestashop.page.canonical, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                },
                body: formData,
            });

            const data = await response.json();

            if(data.success) {
                this.$refs.content.innerHTML = data.html;
                if(!init && data.ps_shoppingcart_html !== null) {
                    const node = createNode(data.ps_shoppingcart_html as string);
                    withEl('.js-dynamic-data-template-module-ps-shoppingcart', el => {
                        el.replaceWith(node);
                    });
                }
            } else {
                this.$refs.content = '';
            }

        }
    },

    setSelectedProduct(product: Product) {
        if(this.selectedProduct && this.selectedProduct.gift_in_cart) {
            return this.updateGift(this.selectedProduct, product);
        }
        this.selectedProduct = product;
        this.selectedGiftCode =product.gift_code;
        this.isOpen = false;
    },

    async updateGift(oldGift: Product, newGift: Product)
    {
        if(this.selectedProduct == newGift || oldGift.gift_code == newGift.gift_code || newGift.gift_in_cart)
            return true;

        await fetch(oldGift.gift_delete_url);
        await fetch(newGift.gift_add_url);

        await this.initGifts(false);

        this.selectedProduct = newGift;
        this.selectedProduct.gift_in_cart = true;
        this.isOpen = false;

        return true;
    },
}));
